import { render } from "./TalkRoomPostNoticeMail.vue?vue&type=template&id=5ebcb678&ts=true"
import script from "./TalkRoomPostNoticeMail.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkRoomPostNoticeMail.vue?vue&type=script&lang=ts&setup=true"

import "./TalkRoomPostNoticeMail.vue?vue&type=style&index=0&id=5ebcb678&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/talkRoom/TalkRoomPostNoticeMail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ebcb678"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ebcb678', __exports__)) {
    api.reload('5ebcb678', __exports__)
  }
  
  module.hot.accept("./TalkRoomPostNoticeMail.vue?vue&type=template&id=5ebcb678&ts=true", () => {
    api.rerender('5ebcb678', render)
  })

}


export default __exports__